module.exports = __webpack_public_path__ + "img/player.50cc91f9.svg";